import { UploadedFile } from "@dtm-frontend/shared/utils";

export function getAttachmentIdsList(attachmentFiles: UploadedFile[] | null) {
    return Object.values(attachmentFiles ?? []).map((attachment: UploadedFile) => attachment.id);
}
